import React, { ReactNode } from "react";

import { useCurrentUser } from "@/features/auth";
import { useListFeatureFlagsQuery } from "@/generated/graphql";

/**
 *
 */
type FeatureFlag = Record<string, boolean>;
/**
 *
 */
type FeatureFlagMap = Record<string, FeatureFlag>;

/**
 *
 */
interface Props {
  children: ReactNode;
}

const FeatureFlagsContext = React.createContext<
  FeatureFlagMap | null | undefined
>(undefined);

export const useFeatureFlags = () => React.useContext(FeatureFlagsContext);
export const useFeatureFlag = (flag: string) => {
  const flags = useFeatureFlags();
  return flags?.[flag];
};

export const useCanAccessFeature = (flag: string) => {
  const featureFlag = useFeatureFlag(flag);
  const currentUser = useCurrentUser();

  return currentUser?.isAdmin || featureFlag?.enabled;
};

/**
 * Provider component that fetches and provides feature flags to the application.
 * @param root0 - Component props
 * @param root0.children - React children nodes to render within the provider
 */
const FeatureFlagsProvider = ({ children }: Props) => {
  const { data } = useListFeatureFlagsQuery();

  return (
    <FeatureFlagsContext.Provider value={data?.listFeatureFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export { FeatureFlagsContext, FeatureFlagsProvider };
